import styled from 'styled-components';
import { H2 } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Line = styled.div`
  width: 100%;
  height: 2px;
  margin-bottom: -10px;
  background-color: ${th('colors.white')};
  opacity: 0.5;
`;

export const Title = styled(H2)`
  font-size: 38px;
  font-family: ${th('fonts.headings')};
  font-weight: normal;
  padding: 20px;

  @media ${sizes.tabletPortrait} {
    padding: 40px;
    font-size: 60px;
  }

  @media ${sizes.desktop} {
    font-size: 80px;
  }

  @media ${sizes.extraLargeDesktop} {
    padding: 100px;
    font-size: 100px;
  }
`;

export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  padding-top: 50px;
  overflow-x: scroll;

  > * {
    margin-right: 40px;

    :last-of-type {
      margin-right: 20px;
    }

    @media ${sizes.desktop} {
      margin-right: 80px;

      :last-of-type {
        margin-right: 80px;
      }
    }
  }

  @media ${sizes.tabletPortrait} {
    padding: 40px;
    padding-top: 50px;
  }

  @media ${sizes.desktop} {
    padding: 40px;
    padding-top: 50px;
  }

  @media ${sizes.extraLargeDesktop} {
    padding: 100px;
    padding-top: 70px;
  }
`;

export const ArrowLeft = styled.div`
  display: none;
  align-self: center;

  @media ${sizes.tabletPortrait} {
    display: block;
  }

  > img {
    width: 100px;
    height: 100px;
  }
`;

export const Spacer = styled.span`
  width: 1px;
  height: 100%;
`;

export const Launching = styled.div`
  position: absolute;
  bottom: 30px;
  left: 20px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 2.2px;
`;
